module.exports = __webpack_public_path__ + "static/media/download.984b1915.svg";